import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';



export const fetchAllSkillsCount = createAsyncThunk(
    'report/fetchAllSkillsReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/skills');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Skills Report');
        }
    }
);


export const fetchAllSkillsMonthly = createAsyncThunk(
    'report/fetchAllSkillsReport',
    async (year : any, { rejectWithValue }) => {
        console.log(year , 'year');
        try {
            const response = await employeeServiceApiInstance.get(`/report/skillsmonthly/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Skills Report');
        }
    }
);

export const fetchAllEmployeeSkills = createAsyncThunk(
    'report/fetchAllSkillsReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/skill/employeeSkills`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Skills Report');
        }
    }
);
export const fetchAllSkillsEmployeeWise = createAsyncThunk(
    'report/fetchAllSkillsReport',
    async (year : any , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/skill/skillsdetails/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Skills Report');
        }
    }
);
